import { Directive, Input, OnChanges, TemplateRef, ViewContainerRef } from '@angular/core';
import { AssetUIModel } from '../models';
import { accessAsset, anyAsset, anyReport } from '../user-access/access-types';
import { CanPipe } from '../user-access/can.pipe';
import { ClientRole } from '../user-access/user-access.service';

interface RoleConfig {
  role?: ClientRole[];
  accessType: string;
  assetInfo?: AssetUIModel;
}

@Directive({
  selector: '[thehubzCanRole]',
  standalone: true,
})
export class HasRoleDirective implements OnChanges {
  @Input('thehubzCanRole') config!: RoleConfig;

  AccessAsset = accessAsset;
  AnyAsset = anyAsset;
  AnyReport = anyReport;

  constructor(
    private templateRef: TemplateRef<unknown>,
    private vcr: ViewContainerRef,
    private canPipe: CanPipe,
  ) {}

  ngOnChanges(): void {
    const { role, accessType } = this.config;
    if (role && Array.isArray(role)) {
      this.handleRoles(role, accessType);
    } else {
      this.addTemplate();
    }
  }

  private handleRoles(roles: ClientRole[], accessType: string): void {
    const allMatch = roles.every((role) => this.checkAccessByType(role, accessType));
    if (allMatch) {
      this.addTemplate();
    } else {
      this.clearTemplate();
    }
  }

  private checkAccessByType(role: ClientRole, accessType: string): boolean {
    switch (accessType) {
      case 'AnyAsset':
        return this.canPipe.transform(anyAsset, role);
      case 'AccessAsset':
        return this.config.assetInfo ? this.canPipe.transform(accessAsset(this.config.assetInfo), role) : false;
      case 'AnyReport':
        return this.canPipe.transform(anyReport, role);
      default:
        return false;
    }
  }

  private addTemplate() {
    this.vcr.clear();
    this.vcr.createEmbeddedView(this.templateRef);
  }

  private clearTemplate() {
    this.vcr.clear();
  }
}
